import { TweenMax, Power2 } from 'gsap';

class PathwayScroller {
  constructor() {
    this.scroller = document.querySelectorAll('.js--pathway-scroller');
    this.isMoving = false;
    this.parallax = true;
    this.initialize();
  }

  initialize() {
    const scrollers = Array.from(this.scroller);
    scrollers.forEach(scroller => {
      scroller.addEventListener('mousemove', this.mouseMove.bind(this));
      scroller.addEventListener('mouseleave', this.mouseLeave.bind(this));
    });
  }

  mouseMove(e) {
    this.moveparallax(e);
  }

  mouseLeave(e) {
    this.resetparallax(e);
    this.isMoving = false;
  }

  moveparallax(e) {
    const x = e.clientX;
    const windowWidth = window.innerWidth;
    const el = e.currentTarget.querySelector('.featured-pathway__right');
    const bounds = el.getBoundingClientRect();
    const item = el.querySelector('.featured-pathway__inner');
    const scrollEl = item.closest('.featured-pathway__track');
    const mouseXRatio = (x - bounds.left + 1) / (windowWidth - bounds.left);
    const trackWidth = item.offsetWidth - (windowWidth - bounds.left);

    TweenMax.to(scrollEl, 0.2, {
      x: -trackWidth * mouseXRatio,
      ease: Power2.easeOut,
    });
  }

  resetparallax() {
    const el = document.querySelectorAll('.featured-pathway__right');

    for (let i = 0; i < el.length; i++) {
      const item = el[i].querySelector('.featured-pathway__inner');
      const scrollEl = item.closest('.featured-pathway__track');

      TweenMax.to(scrollEl, 0.2, {
        x: 0,
        ease: Power2.easeOut,
        onComplete: () => {
          TweenMax.killTweensOf(scrollEl);
        },
      });
    }
  }
}

export default PathwayScroller;
